<template>
    <div class="common-space-between selectMonth">
         <div class="common-items-center">
            <div class="btn" :class='[indexNo==index? "active":""]' v-for="(item,index) in listBtn" @click="getVal(index)">{{item.title}}</div>
            <Month :showTitle="false" ref="mouth" @getDate="getDate"></Month>
         </div>
         <div class="common-items-center">
            <div class="text">{{startData}} ~ {{endData}}</div>  
         </div>
    </div>
</template>
<script>
import Month from '@/components/component-block/block-month.vue'
export default {
    components:{
        Month:Month
    },
    props:{
       listdata:{
          type:Object,
          default:()=>({
               title:"--",
               number:0
          })
       },
       startData:{
         type:String,
         default:""
       },
       endData:{
         type:String,
         default:""
       },
    },
    data: ()=>({
       indexNo:0, 
       listBtn:[]
    }),
    mounted(){
       this.listBtn =  this.$store.state.conText.selectBtn
    },
    methods:{
        getVal(indexNo){
           this.indexNo = indexNo
           let parms = {
                endTime: "",
                startTime: "",
                type: this.listBtn[indexNo].val  
           }
           this.$refs.mouth.clear()
           this.$emit("fMethod", parms) 
        },
        getDate(ev){
           this.indexNo = 4
           let parms = {
                endTime: ev.endDate,
                startTime: ev.startDate,
                type:4
           }
           this.$emit("fMethod", parms) 
        }
    },
}
</script>
<style lang="scss" scoped>
    .btn{
      width: 60px;
      height: 30px;
      font-size: 14px;
      color: #474E5F;
      line-height: 30px;
      text-align: center;
      cursor: pointer; 
      border:1px solid #FF8747;
      border-radius:4px;
      margin-right: 10px;
      color: #FF8747;
    }
    .btn.active{
        color: #EDFAFF;
        background: #FF8747;
    }
    .text{
        font-size: 12px;
        color: #474E5F;
        font-weight: 400;
    }
</style>
